var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1855 4.61244C13.2583 4.68501 13.316 4.77122 13.3554 4.86613C13.3948 4.96105 13.415 5.0628 13.415 5.16556C13.415 5.26832 13.3948 5.37008 13.3554 5.46499C13.316 5.5599 13.2583 5.64611 13.1855 5.71869L7.99177 10.9124C7.93395 10.9704 7.86527 11.0163 7.78966 11.0477C7.71405 11.0791 7.633 11.0952 7.55114 11.0952C7.46929 11.0952 7.38824 11.0791 7.31263 11.0477C7.23702 11.0163 7.16834 10.9704 7.11052 10.9124L1.91677 5.71869C1.61052 5.41244 1.61052 4.91869 1.91677 4.61244C2.22302 4.30619 2.71677 4.30619 3.02302 4.61244L7.55427 9.13744L12.0855 4.60619C12.3855 4.30619 12.8855 4.30619 13.1855 4.61244Z",
    fill: "url(#paint0_linear_3603_85169)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3603_85169",
    x1: 10.4369,
    y1: 9.69141,
    x2: 8.78429,
    y2: 2.20131,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#353A6A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2E4C97"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronIcon);
export default __webpack_public_path__ + "static/media/chevron-icon.459b5d3057d405bd45a7ac18407dc4d2.svg";
export { ForwardRef as ReactComponent };